import { render, staticRenderFns } from "./RequestSection.vue?vue&type=template&id=d8910f6a&scoped=true&"
import script from "./RequestSection.vue?vue&type=script&lang=js&"
export * from "./RequestSection.vue?vue&type=script&lang=js&"
import style0 from "./RequestSection.vue?vue&type=style&index=0&id=d8910f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8910f6a",
  null
  
)

export default component.exports